import React from 'react';
import { footerData } from '../../data/mock';
import { FileText, Github, BookOpen, Twitter, Send } from 'lucide-react';

const linkIcons = {
  Docs: FileText,
  GitHub: Github,
  Whitepaper: BookOpen
};

const socialIcons = {
  X: Twitter,
  Telegram: Send
};

const Footer = () => {
  return (
    <footer className="site-footer" data-testid="site-footer">
      <img src="/brand/mark-white.png" alt="" aria-hidden="true" className="footer-watermark" />
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-brand">
            <div className="footer-logo">
              <img 
                src="/brand/mark-3d.png" 
                alt="Zyber" 
                className="z-logo-small"
              />
              <span className="footer-brand-text" data-testid="footer-brand-text">ZYBERSEC</span>
            </div>
            <p className="footer-tagline">
              Secure Access. Private Execution.<br />
              Risk Absorbed by Design.
            </p>
            <div className="footer-code">
              <code>const zyber = new ZyberSec({'{'} privateKey {'}'});</code>
            </div>
          </div>

          <div className="footer-links">
            <h4>Resources</h4>
            <nav>
              {footerData.links.map((link) => {
                const Icon = linkIcons[link.label];
                return (
                  <a
                    key={link.label}
                    href={link.href}
                    target={link.href.startsWith('http') ? '_blank' : undefined}
                    rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                    className="footer-link"
                    data-testid={`footer-link-${link.label.toLowerCase()}`}
                  >
                    {Icon && <Icon size={14} />}
                    <span>{link.label}</span>
                  </a>
                );
              })}
            </nav>
          </div>

          <div className="footer-social">
            <h4>Connect</h4>
            <div className="social-links">
              {footerData.social.map((social) => {
                const Icon = socialIcons[social.label];
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    data-testid={`footer-social-${social.label.toLowerCase()}`}
                  >
                    {Icon && <Icon size={16} />}
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p data-testid="footer-copyright">{footerData.copyright}</p>
          <p className="footer-token">$ZSEC</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
